// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var BrowserStyle = require("../../../shared-browser/src/BrowserStyle.bs.js");
var BrowserComponents_Spacer = require("../../../shared-browser/src/components/BrowserComponents_Spacer.bs.js");
var BrowserComponents_GetAppButtons = require("../../../shared-browser/src/components/BrowserComponents_GetAppButtons.bs.js");
var WebComponents_SimpleCenteredLogoPage = require("../components/WebComponents_SimpleCenteredLogoPage.bs.js");

var buttons = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.alignSelf(BrowserStyle.center),
      tl: /* [] */0
    });

var Styles = {
  buttons: buttons
};

function WebContainers_GetProfessionalApp(Props) {
  return React.createElement(WebComponents_SimpleCenteredLogoPage.make, {
              children: null,
              title: "Please download or update the Qwick Professionals App and sign in to continue."
            }, React.createElement(BrowserComponents_Spacer.make, {
                  size: /* Large */5
                }), React.createElement(BrowserComponents_GetAppButtons.Professional.make, {
                  className: buttons
                }), React.createElement(BrowserComponents_Spacer.make, {
                  size: /* Large */5
                }));
}

var make = WebContainers_GetProfessionalApp;

exports.Styles = Styles;
exports.make = make;
/* buttons Not a pure module */
